import React, { useState, useMemo } from 'react';
import './Exhibitors.css';
import Header from '../Components/Layout/Header';
import Logo1 from '../Aseets/Img/Logo1.png';
import Footer from '../Components/Layout/Footer';
import Card2 from '../Components/Comman/Card2';
import Button from '../Components/Comman/Button';

const logos = [Logo1, Logo1, Logo1, Logo1, Logo1, Logo1];


const ALL_EXHIBITORS = Array.from({ length: 28 }, (_, i) => ({
  id: i + 1,
  image: Logo1,
  title: 'Egypt Gold',
}));

const ITEMS_PER_PAGE = 12;
const COLS = 4;


function Pagination({ current, total, onChange }) {
  const pages = useMemo(() => {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

    if (current <= 4) return [1, 2, 3, 4, 5, '…', total];
    if (current >= total - 3) return [1, '…', total - 4, total - 3, total - 2, total - 1, total];
    return [1, '…', current - 1, current, current + 1, '…', total];
  }, [current, total]);

  return (
    <nav className="pagination" aria-label="Exhibitors pagination">

      <button
        className="pagination__arrow"
        onClick={() => onChange(current - 1)}
        disabled={current === 1}
        aria-label="Previous page"
      >
        <svg viewBox="0 0 16 16">
          <polyline points="10 3 5 8 10 13" />
        </svg>
      </button>

      <span className="pagination__separator" aria-hidden="true" />

      {pages.map((page, idx) =>
        page === '…' ? (
          <span key={`ellipsis-${idx}`} className="pagination__ellipsis" aria-hidden="true">
            ···
          </span>
        ) : (
          <button
            key={page}
            className={`pagination__page${page === current ? ' pagination__page--active' : ''}`}
            onClick={() => page !== current && onChange(page)}
            aria-label={`Page ${page}`}
            aria-current={page === current ? 'page' : undefined}
          >
            {String(page).padStart(2, '0')}
          </button>
        )
      )}

      <span className="pagination__separator" aria-hidden="true" />

      <button
        className="pagination__arrow"
        onClick={() => onChange(current + 1)}
        disabled={current === total}
        aria-label="Next page"
      >
        <svg viewBox="0 0 16 16">
          <polyline points="6 3 11 8 6 13" />
        </svg>
      </button>
    </nav>
  );
}

const Exhibitors = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(ALL_EXHIBITORS.length / ITEMS_PER_PAGE);

  const pageItems = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    return ALL_EXHIBITORS.slice(start, start + ITEMS_PER_PAGE);
  }, [currentPage]);

  const rows = useMemo(() => {
    const result = [];
    for (let i = 0; i < pageItems.length; i += COLS) {
      result.push(pageItems.slice(i, i + COLS));
    }
    return result;
  }, [pageItems]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    document.querySelector('.section3_exhibitor')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <Header />
      <main>
        <section className="section1-exhibitor">
          <h1 className="exhibitor-text1">EXHIBITORS</h1>
          <p className="exhibitor-text2">
            Discover the world's most prestigious jewelry houses and master craftsmen,
            all gathered under one roof for this exceptional exhibition.
          </p>
        </section>

        <section className="exhibitor_card_div">
          <div className="cards-track-wrapper">
            <div className="cards-track">
              {[...logos, ...logos, ...logos, ...logos].map((logo, i) => (
                <div className="logo-item" key={i}>
                  <img src={logo} alt={`Exhibitor ${(i % logos.length) + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section3_exhibitor">
          <div className="section3_exhibitor_div1">
            <h4 className="section3_exhibitor_text1">Exhibitors</h4>
          </div>

          <div className="section3_exhibitor_div3">
            {rows.map((row, rowIdx) => (
              <div className="section3_exhibitor_div2" key={rowIdx}>
                {row.map((item) => (
                  <Card2 key={item.id} image={item.image} title={item.title} />
                ))}
              </div>
            ))}
          </div>

          <Pagination
            current={currentPage}
            total={totalPages}
            onChange={handlePageChange}
          />
        </section>

        <section className="section4_exhibitor">
            <div className="section4_exhibitor_div1">
                <h3 className="section4_exhibitor_text1">BECOME AN EXHIBITOR</h3>
                <p className="section4_exhibitor_text2">Join the world's most prestigious jewelry exhibition and showcase your masterpieces to collectors and enthusiasts from around the globe.</p>
                <div className='section4_exhibitor_div2'>
                    <Button text="Apply Now"/>
                    <Button text="View Details"/>
                </div>
            </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Exhibitors;